/**
 * Route name → source file for Appium / WDIO diagnostics.
 * Extend when adding screens you assert against in e2e.
 */
export const SCREEN_FILE_MAP: Record<string, string> = {
  // Auth / root
  LoadingScreen: 'src/navigation/screens/LoadingScreen/loadingScreen.tsx',
  Loading: 'src/navigation/screens/LoadingScreen/loadingScreen.tsx',
  Login: 'src/navigation/screens/TopLevel/LoginScreen/LoginScreen.tsx',
  NotFound: 'src/navigation/screens/TopLevel/NotFoundScreen.tsx',

  // Dashboard
  Welcome: 'src/navigation/screens/MidLevel/WelcomeScreen/WelcomeScreen.tsx',
  Integrations: 'src/navigation/screens/MidLevel/IntegrationsScreen/IntegrationScreen.tsx',
  Help: 'src/navigation/screens/MidLevel/HelpScreen.tsx',
  ComingSoonScreen: 'src/navigation/screens/NonMenu/ComingSoonScreen.tsx',
  Invitations: 'src/navigation/screens/MidLevel/DataScreen/InvitationsScreen.tsx',
  Community: 'src/navigation/screens/MidLevel/CommunityScreen/Community.tsx',
  Reminders: 'src/navigation/screens/MidLevel/RemindersScreen.tsx',
  Marketplace: 'src/navigation/screens/MidLevel/MarketPlaceScreen.tsx',

  // Settings
  SettingsMenu: 'src/navigation/screens/MidLevel/SettingsScreens/SettingsMenu.tsx',
  Profile: 'src/navigation/screens/MidLevel/SettingsScreens/ProfileScreen.tsx',
  Context: 'src/navigation/screens/MidLevel/SettingsScreens/Context.tsx',
  Achievements: 'src/navigation/screens/MidLevel/SettingsScreens/AchievementsScreen.tsx',
  Statistics: 'src/navigation/screens/MidLevel/SettingsScreens/StatisticsScreen.tsx',
  Company: 'src/navigation/screens/MidLevel/SettingsScreens/CompanyScreen.tsx',
  Upgrade: 'src/navigation/screens/MidLevel/UpgradeScreen/UpgradeScreen.tsx',
  Affiliate: 'src/navigation/screens/MidLevel/SettingsScreens/AffiliateScreen.tsx',
  AgentUsage: 'src/navigation/screens/MidLevel/SettingsScreens/AgentUsageScreen.tsx',
  StoreSettings: 'src/navigation/screens/TopLevel/StoreScreen/StoreSettings.tsx',
  API: 'src/navigation/screens/MidLevel/SettingsScreens/APIScreen.tsx',
  Credits: 'src/navigation/screens/MidLevel/SettingsScreens/CreditsScreen.tsx',

  // Data
  Capture: 'src/navigation/screens/MidLevel/DataScreen/CaptureScreen/CaptureScreen.tsx',
  Upload: 'src/navigation/screens/MidLevel/DataScreen/UploadScreen.tsx',
  CreateData: 'src/navigation/screens/MidLevel/DataScreen/CreateDataScreen.tsx',
  DataBrowser: 'src/navigation/screens/LowLevel/DataBrowserScreen.tsx',
  TimeLine: 'src/navigation/screens/LowLevel/TimeLineScreen.tsx',
  DataHandler: 'src/navigation/screens/MidLevel/DataScreen/DataHandler.tsx',
  PublicData: 'src/navigation/screens/MidLevel/DataScreen/PublicDataScreen/PublicDataScreen.tsx',
  EmailTemplates: 'src/navigation/screens/MidLevel/DataScreen/TemplatesScreen/EmailTemplates.tsx',
  InvoiceTemplates: 'src/navigation/screens/MidLevel/DataScreen/TemplatesScreen/InvoiceTemplates.tsx',
  DataMenu: 'src/navigation/screens/MidLevel/DataScreen/DataMenu.tsx',
  DataTemplates: 'src/navigation/screens/MidLevel/DataScreen/DataTemplates.tsx',
  WhatsappTemplates: 'src/navigation/screens/MidLevel/DataScreen/WhatsappTemplates.tsx',
  CreateEmailTemplate: 'src/navigation/screens/LowLevel/CreateEmailTemplateScreen.tsx',
  NewCreativeTemplate:
    'src/navigation/screens/MidLevel/DataScreen/TemplatesScreen/CreativeTemplates/NewCreativeTemplate.tsx',
  DocumentTemplate: 'src/navigation/screens/MidLevel/DataScreen/TemplatesScreen/DocumentTemplate.tsx',
  DocumentTemplateEditor:
    'src/navigation/screens/MidLevel/DataScreen/TemplatesScreen/DocumentTemplates/DocumentTemplateEditor.tsx',
  IndividualPublicData:
    'src/navigation/screens/MidLevel/DataScreen/PublicDataScreen/IndividualPublicDataScreen.tsx',
  DataFavourites: 'src/navigation/screens/MidLevel/DataScreen/DataFavourites/DataFavouritesScreen.tsx',
  Product: 'src/navigation/screens/LowLevel/ProductScreen.tsx',
  Invoice: 'src/navigation/screens/MidLevel/DataScreen/TemplatesScreen/InvoiceTemplates/InvoiceScreen.tsx',
  ActionHandler: 'src/navigation/screens/MidLevel/DataScreen/ActionHandler/ActionHandlerScreen.tsx',
  Utilities: 'src/navigation/screens/MidLevel/DataScreen/Utilities.tsx',
  PreviewEmailTemplate: 'src/navigation/screens/MidLevel/DataScreen/TemplatesScreen/PreviewEmailTemplate.tsx',
  CreativeTemplates: 'src/navigation/screens/MidLevel/DataScreen/TemplatesScreen/CreativeTemplates.tsx',
  Media: 'src/navigation/screens/MidLevel/DataScreen/MediaScreen.tsx',
  DataBubble: 'src/navigation/screens/MidLevel/DataScreen/DataBubble/DataBubbleScreen.tsx',

  // Project Management — e2e route probe targets
  ProjectMenu: 'src/navigation/screens/MidLevel/ProjectManagementScreen/ProjectMenu.tsx',
  ProjectsList: 'src/navigation/screens/MidLevel/ProjectManagementScreen/ProjectManagementScreen.tsx',
  IndividualProjectPage: 'src/navigation/screens/MidLevel/ProjectManagementScreen/IndividualProjectPage.tsx',
  CompletedProjects: 'src/navigation/screens/MidLevel/ProjectManagementScreen/CompletedProjects.tsx',
  Templates: 'src/navigation/screens/MidLevel/ProjectManagementScreen/ProjectTemplate.tsx',
  ProjectFavourites: 'src/navigation/screens/MidLevel/ProjectManagementScreen/ProjectFavourites.tsx',
  ActiveProjects: 'src/navigation/screens/MidLevel/ProjectManagementScreen/ProjectManagementScreen.tsx',
  ProjectManagement: 'src/navigation/screens/MidLevel/ProjectManagementScreen/ProjectManagementScreen.tsx',

  // Easy Mode
  EasyMode: 'src/navigation/screens/MidLevel/EasyModeScreen/EasyModeScreen.tsx',

  // Sales
  SalesMenu: 'src/navigation/screens/MidLevel/SalesScreen/SalesMenu.tsx',
  SalesDashboard: 'src/navigation/screens/MidLevel/SalesScreen/SalesDashboard.tsx',
  PastSales: 'src/navigation/screens/MidLevel/SalesScreen/PastSalesDashboard.tsx',
  SalesLogistics: 'src/navigation/screens/MidLevel/SalesScreen/PastSalesDashboard.tsx',

  // Calendar
  CalendarScreen: 'src/navigation/screens/MidLevel/CalendarScreen/CalendarScreen.tsx',
  CalendarMenu: 'src/navigation/screens/MidLevel/CalendarScreen/screens/CalendarMenu.tsx',

  // Reports
  ReportsScreen: 'src/navigation/screens/MidLevel/ReportsScreen/ReportsScreen.tsx',
  ReportDashboard: 'src/navigation/screens/MidLevel/ReportsScreen/ReportDashboardScreen.tsx',

  // Mail
  MailScreen: 'src/navigation/screens/MidLevel/MailScreen/MailScreen.tsx',
  MailLoginScreen: 'src/navigation/screens/MidLevel/MailScreen/MailLoginScreen.tsx',
  ComposeMail: 'src/navigation/screens/MidLevel/MailScreen/ComposeMailScreen.web.tsx',

  // Knowledge
  KnowledgeMenu: 'src/navigation/screens/MidLevel/KnowledgeScreen/KnowledgeMenu.tsx',
};

export function getScreenFileForRoute(routeName: string | null | undefined): string | null {
  if (!routeName) return null;
  return SCREEN_FILE_MAP[routeName] ?? null;
}

/**
 * Screen categories for e2e test routing.
 * Used to group screens and make route-based navigation decisions.
 */
export const SCREEN_CATEGORIES: Record<string, string> = {
  // Project Management
  ProjectMenu: 'project_management',
  ProjectsList: 'project_management',
  IndividualProjectPage: 'project_management',
  CompletedProjects: 'project_management',
  Templates: 'project_management',
  ProjectFavourites: 'project_management',
  ActiveProjects: 'project_management',
  ProjectManagement: 'project_management',

  // Easy Mode
  EasyMode: 'easy_mode',

  // Sales
  SalesMenu: 'sales',
  SalesDashboard: 'sales',
  PastSales: 'sales',
  SalesLogistics: 'sales',

  // Calendar
  CalendarScreen: 'calendar',
  CalendarMenu: 'calendar',

  // Reports
  ReportsScreen: 'reports',
  ReportDashboard: 'reports',

  // Data
  Capture: 'data',
  DataBrowser: 'data',
  TimeLine: 'data',
  DataHandler: 'data',
  CreateData: 'data',
  DataTemplates: 'data',
  EmailTemplates: 'data',

  // Settings
  SettingsMenu: 'settings',
  Profile: 'settings',
  Company: 'settings',
  AgentUsage: 'company',
  Upgrade: 'settings',

  // Dashboard
  Welcome: 'dashboard',
  Help: 'dashboard',

  // Auth
  Login: 'auth',
  LoadingScreen: 'auth',

  // Mail
  MailScreen: 'mail',
  MailLoginScreen: 'mail',
  ComposeMail: 'mail',

  // Knowledge
  KnowledgeMenu: 'knowledge',
};

/**
 * Get the screen category for a route name (useful for e2e routing).
 */
export function getScreenCategory(routeName: string | null | undefined): string | null {
  if (!routeName) return null;
  return SCREEN_CATEGORIES[routeName] ?? null;
}
